import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getAccessLevelsOfRole = (roleId:any,payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ACCESS_LEVEL_DETAILS.METHOD](APIConfig.GET_ACCESS_LEVEL_DETAILS.URL(roleId), payload);
}

const updateModuleAccess = (roleId:any,payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPDATE_MODULE_ACCESS.METHOD](APIConfig.UPDATE_MODULE_ACCESS.URL(roleId), payload);
}

const addBulkAccessLevels = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_BULK_ACCESS_LEVELS.METHOD](APIConfig.ADD_BULK_ACCESS_LEVELS.URL, payload);
}

const getStaticAccessLevelData = (payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.GET_INITIAL_STATIC_ACCESS_LEVEL_DETAILS.METHOD](APIConfig.GET_INITIAL_STATIC_ACCESS_LEVEL_DETAILS.URL, payload);

}

const addNewAclRole = (payload:any) =>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_ACL_ROLE.METHOD](APIConfig.ADD_ACL_ROLE.URL, payload);
}

const AccessLevelService = {
    getAccessLevelsOfRole,
    updateModuleAccess,
    addBulkAccessLevels,
    addNewAclRole,
    getStaticAccessLevelData
}

export default AccessLevelService;
